import React from 'react';
import { Typography } from '@mui/material';
import { gql } from '@apollo/client';
import rpcShared from '@rockpapercoin/rpc-shared';
import { getDetailLink, linkObject } from '../../../lib/helpers';
import { LinkObjectType } from '../../../lib/helpers/types';
import { InvoiceFullyPaidEventPropsEventFragment } from '#types';
import { FlattenedUser } from '../../../types/user';
import { CalendarSourceType } from '../../CalendarLinks';
import { DefaultEventProps } from '../contract/helpers';

export const invoiceFullyPaidEventPropsEventFragment = gql`
	fragment invoiceFullyPaidEventPropsEvent on Event {
		id
		category
		invoice {
			id
			title
			eventDate
			contact {
				...getViewingUserDocumentRelationshipContact
			}
		}
	}
	${ rpcShared.contacts.getViewingUserDocumentRelationshipContactFragment }
`;

export const getInvoiceFullyPaidEventProps = (
	eventProps: DefaultEventProps & {
		event: InvoiceFullyPaidEventPropsEventFragment;
	},
	user: FlattenedUser
): DefaultEventProps => {
	const updatedEventProps = { ...eventProps };
	const { invoice } = updatedEventProps.event;

	if ( !invoice ) {
		throw new Error( 'No invoice provided for InvoiceFullyPaid event' );
	}

	updatedEventProps.icon = 'dollar';
	updatedEventProps.message = (
		<Typography>Done! { linkObject( invoice ) } has been paid in full!</Typography>
	);
	updatedEventProps.links = [
		{
			type: 'secondary',
			text: 'View',
			link: getDetailLink( {
				object: invoice,
				type: LinkObjectType.Invoice,
			} ),
		},
	];

	if ( invoice.eventDate ) {
		const viewingUserId = user?.isLoggedIn ? user.user.id : undefined;
		const invoiceContact = invoice.contact;
		const { viewingUserIsAdminOrManager, viewingUserIsAssignedMember } =
			invoiceContact && viewingUserId
				? rpcShared.contacts.getViewingUserDocumentRelationship( {
					contact: invoiceContact,
					viewingUserId,
				  } )
				: {
					viewingUserIsAdminOrManager: false,
					viewingUserIsAssignedMember: false,
				  };

		const canSendCalendarInvite =
			viewingUserIsAdminOrManager || viewingUserIsAssignedMember;
		updatedEventProps.calendarLinksProps = {
			sourceType: CalendarSourceType.INVOICE,
			sourceId: invoice.id,
			iconOnly: false,
			canSendCalendarInvite,
		};
	}

	return updatedEventProps;
};
